// extracted by mini-css-extract-plugin
export default {"Container":"Slider_Container__2EysF","Content":"Slider_Content__LeVqU"};